<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="CONFIGURACIÓN" key="1">
        <a-row>
          <g-master name="configuracion"
                    @params="paramsTable"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
          >
            <template slot="customButton">
              <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
            </template>
            <span slot="estadoRenderer" slot-scope="{text}">
              <div v-if="text ==='INACTIVO'">
                <a-tag color="red">{{text}}</a-tag>
              </div>
              <div v-if="text ==='ACTIVO'">
                <a-tag color="blue">{{text}}</a-tag>
              </div>
            </span>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Clave')">
                    <a-input  style="width: 100%;" v-decorator="['key', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Valor')">
                    <a-textarea auto-size style="width: 100%;" v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tpay: {
          h_lookup_type: 'TIPO PAGO',
          use_code: true
        },
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'configuration',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_configuration'
            },
            columns: [
              {title: '#', dataIndex: 'id_configuration', sorter: true},
              {title: 'Clave', dataIndex: 'key', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'key'},
            {name: 'value'}
          ]
        },
        endpointExcel: 'configuration_/downloadExcel',
        fileNameExcel: 'Configuracion',
        paramsT: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Configuration/Configuration.vue